export default function Navigation() {
  return (
    <nav className="fixed w-full bg-white/80 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <img src="favicon.svg" alt="Logo" className="h-8 w-8" />
            <a href="https://nextapi.org" className="ml-2 text-xl font-bold text-gray-900">NextAPI.org</a>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <a href="#models" className="text-gray-600 hover:text-gray-900">Models</a>
            <a href="https://api.nextapi.org/pricing" className="text-gray-600 hover:text-gray-900" target="_blank">Pricing</a>
            <a href="https://api.nextapi.org/about" className="text-gray-600 hover:text-gray-900" target="_blank">Docs</a>
            <a
              href="https://api.nextapi.org"
              rel="noreferrer"
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Get Started
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}